import { render } from "./CurrentPassword.vue?vue&type=template&id=62108226"
import script from "./CurrentPassword.vue?vue&type=script&lang=js"
export * from "./CurrentPassword.vue?vue&type=script&lang=js"
script.render = render

export default script